import { useActionWithConfirmation } from '@/components/confirmationModals/useActionWithConfirmation';

type DeleteFunction = (id: string) => Promise<any>;

export function useDeleteUnitWithConfirmation(deleteFunction: DeleteFunction) {
  return useActionWithConfirmation({
    confirmedAction: async (id: string) => await deleteFunction(id),
  });
}
